/* eslint-disable import/prefer-default-export */

import {
    // 默认不需要引入，此处引入是因为 kline 组件里面的图表需要用到
    ElPopover,
    ElScrollbar,
    ElLoading,
} from 'element-plus';

const components = [
    ElPopover,
    ElScrollbar,
];

const plugins = [
    ElLoading,
];

/**
 * 安装到组件实例中
 *
 * @param {Object} app 实例
 */
export const install = (app) => {
    components.forEach((component) => {
        app.component(component.name, component);
    });
    plugins.forEach((plugin) => {
        app.use(plugin);
    });
};
